<section class="content widget">
  <app-return-conditions></app-return-conditions>
</section>
